<template>
  <div class="zszp">
    <div class="search">
      <input type="text" name="" id="" v-model="name" />
      <button @click="search">search</button>
      <i class="iconfont icon-sousuo"></i>
    </div>
    <div class="select">
      <button v-show="selected == 1" class="btn1" @click="openPicker(true)">
        <span>{{ zsxuanze }}</span><i class="iconfont icon-xia"></i>
      </button>
      <button v-show="selected == 2" class="btn2" @click="openPicker(false)">
        <span>{{ zpxuanze }} </span><i class="iconfont icon-xia"></i>
      </button>
      <mt-popup v-model="popupVisible" class="selectDown" position="bottom">
        <div class="buttomGroup">
          <span @click="popupVisible = false">Cancel</span>
          <span @click="inSelect">Yes</span>
        </div>
        <mt-picker :slots="slots" @change="onValuesChange"></mt-picker>
      </mt-popup>
    </div>
    <div class="con">
      <mt-navbar v-model="selected">
        <mt-tab-item id="1">Exhibitor</mt-tab-item
        ><!-- 展商 -->
        <mt-tab-item id="2">Product Categories</mt-tab-item
        ><!-- 展品 -->
      </mt-navbar>
      <mt-tab-container v-model="selected">
        <mt-tab-container-item id="1">
          <ul
            v-show="zsList.list.length > 0"
            v-infinite-scroll="loadMore"
            :infinite-scroll-disabled="moreLoading"
            infinite-scroll-distance="1"
            infinite-scroll-immediate-check="false"
          >
            <li
              class="liItemL"
              v-for="item in zsList.list"
              :key="'A' + item.id"
              @click="$router.push('/exhibitor/details/' + item.id + '/' + item.ocid)"
            >
              <div class="liLeft">
                <img :src="item.corplogo_cn" alt="" />
              </div>
              <div class="liRight">
                <h6>{{ item.corpname_en }}</h6>
                <p>Booth number:{{ item.booth }}</p>
                <p>Booth area:{{ item.area }}m²</p>
              </div>
            </li>
            <li class="more_loading">
              <span v-show="zsList.list.length < zsList.listnum">
                <div class="m_upload">
                  <mt-spinner type="snake" color="#00ccff" :size="20"></mt-spinner>
                  <span>Loading...</span>
                </div>
              </span>
              <span v-show="zsList.list.length >= zsList.listnum" class="over">Final Page</span
              >
            </li>
          </ul>
          <div v-show="zsList.list.length <= 0" class="zanwu">
            <div>
              <img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/without.png" />
            </div>
            <p class="p">No data is available!</p>
          </div>
        </mt-tab-container-item>
        <mt-tab-container-item id="2">
          <ul
            v-show="zpList.list.length > 0"
            class="ulListR"
            v-infinite-scroll="loadMore2"
            :infinite-scroll-disabled="moreLoading1"
            infinite-scroll-distance="1"
          >
            <li
              class="liItemR"
              v-for="item in zpList.list"
              :key="item.id"
              @click.stop=" $router.push('/exhibit/details/' + item.id + '/' + item.ocid) "
            >
              <div>
                <img :src="item.img_url" />
              </div>
              <p>{{ item.proname_en }}</p>
              <img
                v-if="item.coll == 1"
                src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/like.png"
                @click.stop="modifyLike(item.id)"
              />
              <img
                v-else-if="item.coll == 2"
                src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/like_1.png"
                @click.stop="modifyLike(item.id)"
              />
            </li>
            <li class="more_loading">
              <span v-show="zpList.list.length < zpList.listnum">
                <div class="m_upload">
                  <mt-spinner
                    type="snake"
                    color="#00ccff"
                    :size="20"
                  ></mt-spinner>
                  <span>Loading...</span>
                </div>
              </span>
              <span v-show="zpList.list.length >= zpList.listnum" class="over">Final Page</span >
            </li>
          </ul>
          <div v-show="zpList.list.length <= 0" class="zanwu">
            <div>
              <img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/without.png" />
            </div>
            <p class="p">No data is available!</p>
          </div>
        </mt-tab-container-item>
      </mt-tab-container>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import {
  Popup,
  Picker,
  Navbar,
  TabItem,
  TabContainer,
  TabContainerItem,
  InfiniteScroll,
  Spinner,
} from "mint-ui";
Vue.use(InfiniteScroll);
import "mint-ui/lib/popup/style.css";
import "mint-ui/lib/picker/style.css";
import "mint-ui/lib/navbar/style.css";
import "mint-ui/lib/spinner/style.css";
import {
  reqExhibitList,
  reqSortList,
  reqExhibitorList,
  reqProCollDo,
} from "../../../api";
export default {
  components:{
    'mt-popup':Popup,
    'mt-picker':Picker,
    'mt-navbar':Navbar,
    'mt-tab-item':TabItem,
    'mt-tab-container':TabContainer,
    'mt-tab-container-item':TabContainerItem,
    'mt-spinner':Spinner,
  },
  data() {
    return {
      slots: [
        {
          id: 0,
          values: [],
        },
      ],
      popupVisible: false,
      name: "", //搜索内容
      selected: "1", //当前切换（展商、展品）

      YzsflList: [//展商分类
        {
          class_name_cn: "全部",
          class_name_en: "all",
          id: "",
        },
        {
          class_name_cn: "W1 展区",
          class_name_en: "W1",
          id: "W1",
        },
        {
          class_name_cn: "W2 展区",
          class_name_en: "W2",
          id: "W2",
        },
        {
          class_name_cn: "W3 展区",
          class_name_en: "W3",
          id: "W3",
        },
        {
          class_name_cn: "E1 展区",
          class_name_en: "E1",
          id: "E1",
        },
        {
          class_name_cn: "E2 展区",
          class_name_en: "E2",
          id: "E2",
        },
        {
          class_name_cn: "E3 展区",
          class_name_en: "E3",
          id: "E3",
        },
        {
          class_name_cn: "E4 展区",
          class_name_en: "E4",
          id: "E4",
        },
      ], //展商分类
      zsloading: false, //展商请求中
      zsList: { list: [], listnum: 0, pagelistnum: 0, thispage: 0 }, //展商列表
      zsxuanze: "all", //展商分类当前选项
      zsflList: [
        {
          //展商分类列表
          id: 0,
          values: ["all", "W1", "W2", "W3", "E1", "E2", "E3", "E4"],
        },
      ],

      YzpflList: [], //展品分类
      zploading: true, //展品请求中
      zpList: { list: [], listnum: 0, pagelistnum: 0, thispage: 0 }, //展品列表
      zpflId: 0,
      zpxuanze: "all", //展品分类当前选项
      zpflList: [
        {
          //展品分类列表
          id: 1,
          values: [],
        },
      ],
      moreLoading: false,
      moreLoading1: false,
    };
  },
  mounted() {
    this.zsxuanze='all'
    this.exhibitorList();
    this.moreLoading1 = false;
    sessionStorage.setItem("selected", "/exhibitor");
  },
  methods: {
    search() {
      // 搜素
      if (this.selected * 1 == 1) {
        //展商
        this.exhibitorList();
      } else {
        //展品
        this.exhibitList();
      }
    },

    openPicker(falg) {
      // 选择框
      this.popupVisible = true;
      if (falg) {
        //展商
        this.slots = this.zsflList;
      } else {
        //展品
        this.slots = this.zpflList;
      }
    },

    onValuesChange(picker, values) {//下拉选择
      if (picker.slots[0].id == 0 && values.length) {
        this.zsxuanze = values[0];
      } else if (picker.slots[0].id == 1 && values.length) {
        this.zpxuanze = values[0];
      }
    },

    inSelect() {
      // 分类选择
      if (this.selected == 1) {
        //展商
        // let item = this.YzsflList.find(
        //   (item) => item.class_name_en == this.zsxuanze
        // );
        this.zsflId = this.zsxuanze;
        this.exhibitorList();
        this.popupVisible = false;
      } else {
        //展品
        let item = this.YzpflList.find(
          (item) => item.class_name_en == this.zpxuanze
        );
        this.zpflId = item.id;
        this.exhibitList();
        this.popupVisible = false;
      }
    },

    async loadMore() {
      // 展商懒加载
      // console.log(1111,this.zsList.list.length,this.zsList.listnum*1);
      if (
        this.selected == 2 ||
        this.zsList.list.length >= this.zsList.listnum * 1
      ) {
        return;
      }
      // console.log(this.zsList);
      this.exhibitorList(this.zsList.thispage * 1 + 1, false);
    },

    async exhibitorList(page = 1, falg = true) {
      // 展商列表请求
      this.zsloading = true;
      const response = await reqExhibitorList(page, this.zsflId, this.name);
      if (response.code == 0) {
        if (falg) {
          this.zsList = {
            list: response.resilt,
            listnum: response.listnum,
            pagelistnum: response.pagelistnum,
            thispage: response.thispage,
          };
        } else {
          this.zsList.list.push(...response.resilt);
          this.zsList.thispage = response.thispage;
          this.zsList.listnum = response.listnum;
          this.zsList.pagelistnum = response.pagelistnum;
        }
      } else {
        this.zsList = {
          list: [],
          listnum: 0,
          pagelistnum: 0,
          thispage: 0,
        };
        this.zsloading = false;
      }
    },

    loadMore2() {
      // 展品懒加载
      // console.log(123);
      if (
        this.selected == 1 ||
        this.zpList.list.length >= this.zpList.listnum * 1
      ) {
        return;
      }

      this.exhibitList(this.zpList.thispage * 1 + 1, false);
    },

    async modifyLike(id) {
      // 收藏状态设置
      // 传来的数据根据下标替换上item
      // 把修改的发送请求
      const response = await reqProCollDo(id);
      if (response.code == 0) {
        let index = this.zpList.list.findIndex(
          (newitem) => newitem.id * 1 == id * 1
        );
        this.zpList.list[index].coll = response.is_coll;
      }
    },

    async sortList() {
      // 展品分类列表请求
      const response = await reqSortList();
      if (response.code == 0) {
        this.YzpflList = response.resilt;
        let list = ["all"];
        response.resilt.forEach((item) => {
          list.push(item.class_name_en);
        });
        this.zpflList[0] = {
          id: 1,
          values: list,
        };
      }
    },

    async exhibitList(page = 1, falg = true) {
      //展品列表请求
      this.zploading = true;
      const response = await reqExhibitList(page, this.zpflId, this.name);
      if (response.code == 0) {
        if (falg) {
          this.zpList = {
            list: response.resilt,
            listnum: response.listnum,
            pagelistnum: response.pagelistnum,
            thispage: response.thispage,
          };
        } else {
          this.zpList.list.push(...response.resilt);
          this.zpList.thispage = response.thispage;
          this.zpList.listnum = response.listnum;
          this.zpList.pagelistnum = response.pagelistnum;
        }
      } else {
        this.zpList = {
          list: [],
          listnum: 0,
          pagelistnum: 0,
          thispage: 0,
        };
        this.zploading = false;
      }
    },
  },
  watch: {
    selected() {
      // console.log(1222);
      if (this.selected == 1) {
        this.exhibitorList();
        this.moreLoading = false;
        this.moreLoading1 = true;
      } else {
        this.sortList();
        this.exhibitList();
        this.moreLoading = true;
        this.moreLoading1 = false;
      }
    },
  },
};
</script>

<style scoped>
.mint-navbar .mint-tab-item {
  width: 50%;
}
.zszp {
  height: 100%;
  width: 100%;
  padding-top: 20px;
  color: #808080;
}
.search {
  position: relative;
  margin-bottom: 15px;
}
.search input {
  height: 30px;
  width: 295px;
  background-color: transparent;
  box-sizing: border-box;
  padding-left: 30px;
  border: 1px solid #e6e6e6;
  border-right-style: none;
  outline: none;
  vertical-align: middle;
}
.search button {
  width: 60px;
  height: 30px;
  box-sizing: border-box;
  border: none;
  color: white;
  background-color: #ff840c;
  outline: none;
  vertical-align: middle;
}
.search i {
  position: absolute;
  left: 18px;
  top: 5px;
}

.select {
  margin-bottom: 15px;
}
.select button {
  height: 30px;
  padding-left: 10px;
  padding-right: 10px;
  text-align: left;
  background-color: transparent;
  outline: none;
  border: 1px solid #e6e6e6;
  box-sizing: border-box;
  color: #999999;
  line-height: 30px;
  overflow: hidden;
}
.btn1 {
  width: 100%;
}
.btn2 {
  width: 100%;
}
.select button i {
  font-size: 12px;
  float: right;
}
.con {
  margin-left: -10px;
  margin-right: -10px;
}
.mint-popup-bottom {
  height: 50%;
  width: 100%;
}
.buttomGroup {
  display: flex;
  justify-content: space-between;
  padding: 10px 20px;
  box-shadow: 1px 0px 20px rgba(0, 0, 0, 0.2);
  color: #008baf;
  font-size: 16px;
}
.buttomGroup span:first-child {
  color: #000;
}
.mint-navbar {
  height: 40px;
  box-sizing: border-box;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
}
.mint-navbar .mint-tab-item {
  font-size: 16px;
  padding: 10px 0;
}

/* 展商列表 */
.liItemL {
  height: 100px;
  padding: 20px;
  margin: 20px 10px 0;
  display: flex;
  box-sizing: border-box;
  background-color: white;
  border-radius: 5px;
  box-shadow: 3px 3px 20px rgba(0, 0, 0, 0.2);
}
.liLeft {
  width: 100px;
  height: 60px;
  overflow: hidden;
  margin-right: 10px;
}
.liRight {
  width: 205px;
}
.liRight h6 {
  font-size: 13px;
  color: #000;
  font-weight: 600;
  line-height: 25px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.liRight p {
  line-height: 20px;
}

.ulListR {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 10px;
}
.liItemR {
  position: relative;
  width: 172.5px;
  padding: 20px;
  margin-bottom: 10px;
  background-color: white;
  box-sizing: border-box;
  border-radius: 5px;
}
.liItemR > div {
  width: 132.5px;
  height: 132.5px;
}
.liItemR > p {
  text-align: center;
  padding-top: 8px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.liItemR > img {
  position: absolute;
  right: 5px;
  top: 5px;
  font-size: 21px;
  color: #dcdcdc;
  width: 21px;
  height: 21px;
  cursor: pointer;
}

.more_loading {
  margin-top: 10px;
}

.zszp >>> .picker-slot {
  font-size: 14px;
}

.zanwu {
  width: 100%;
  text-align: center;
  padding-top: 60px;
}
.zanwu img {
  width: 200px;
  margin-bottom: 20px;
}
</style>